<template>
  <div class="send-basket">
    <div class="col s12">
      <h2>MONTANT DU PANIER</h2>
      <basket-total></basket-total>

      <div class="container">
        <!-- Civilité -->
        <div class="row">
          <div class="col s12">
            <label>Civilité</label>
            <select class="browser-default" v-model="civility">
              <option value="M." selected>Monsieur</option>
              <option value="Mme">Madame</option>
            </select>
          </div>
        </div>

        <!-- Nom du client -->
        <div class="row">
          <div class="input-field col s12">
            <input id="client_name" type="text" v-model="client_name" autocomplete="off">
            <label for="client_name" v-bind:class="{ active: client_name }">Nom du client</label>
          </div>
        </div>

        <!-- Type de livraison -->
        <div class="row">
          <div class="col s12">
            <label>Type de livraison</label>
            <select class="browser-default" v-model="delivery_type">
              <option value="0" selected>Remis en main propre</option>
              <option value="4">A l'accueil</option>
              <option value="1">Au portail</option>
              <option value="2">A domicile</option>
              <option value="3">Réservation</option>
            </select>
          </div>
        </div>

        <!-- Si le mode de livraison choisi == A domicile, on affiche les champs supplémentaires via le composant -->
        <home-delivery v-if="delivery_type == 2"></home-delivery>

        <!-- Si le mode de livraison choisi == A domicile, on affiche les champs supplémentaires via le composant -->
        <booking v-if="delivery_type == 3"></booking>

        <!-- Boutton d'envoi de la commande -->
        <div class="center-align">
          <button class="btn waves-effect waves-light btn-brico" @click="send">
            Envoyer la commande
            <i class="material-icons right">send</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasketTotal from "@/components/Basket/BasketTotal.vue";
import HomeDelivery from "@/components/Delivery/HomeDelivery.vue";
import Booking from "@/components/Delivery/Booking.vue";

export default {
  computed: {
    civility: {
      get() {
        return this.$store.state.civility;
      },
      set(value) {
        this.$store.commit("updateCivility", value);
      }
    },
    client_name: {
      get() {
        return this.$store.state.client_name;
      },
      set(value) {
        this.$store.commit("updateClientName", value);
      }
    },
    delivery_type: {
      get() {
        return this.$store.state.delivery_type;
      },
      set(value) {
        this.$store.commit("updateDeliveryType", value);
      }
    }
  },
  methods: {
    send: function(){
      this.$router.push('/send');
    }
  },
  components: {
    BasketTotal,
    HomeDelivery,
    Booking
  }
};
</script>


<style>
.send-basket {
  color: #fff;
  background-color: #2d373d;
  padding-top: 0.5em;
  padding-bottom: 2em;
}
.send-basket h2 {
  text-align: center;
  font-size: 2rem;
  padding-bottom: 0.5em;
  border-bottom: 1px #fff solid;
}
.send-basket input, .send-basket textarea{
  color: #fff;
}
.send-basket button {
  margin-top: 2em;
}
</style>
